import { useEffect } from "react";
import { message } from "antd";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import streen_theme from "../css/theme.scss";

import { Modal } from "antd";

export default function useStoryCharacters({
  storyId, selectedCharacters, setSelectedCharacters, deletedCharacters, setDeletedCharacters, selectedSentences, setSelectedSentences, setDeletedSentences,
}) {

  //#region CONSTS 
    const COLOR_OPTIONS = [streen_theme.brown3, streen_theme.olive4, streen_theme.orange3, streen_theme.red4, streen_theme.yellow3, streen_theme.teal4, streen_theme.violet4, streen_theme.grey2,
    streen_theme.sienna, streen_theme.mint, streen_theme.brown4, streen_theme.pink, streen_theme.avocado, streen_theme.marine, streen_theme.green, streen_theme.grey1,];
  // -----------------------------
  // LOAD CHARACTERS (EDIT MODE)
  // -----------------------------
  useEffect(() => {
    let isMounted = true;
    const fetchCharacters = async () => {
      console.log("?T?T?t story id", storyId);
      if (!storyId) return;

       // do not reload if we already have local characters
    if (selectedCharacters.length > 0) {
      return;
    }

      try {
        const res = await axios.get(
          `/api/characters/?storycharid=${storyId}`
        );

        console.log("CHARACTER API RESPONSE:", res.data);

        if (!isMounted) return;

        const loaded = (res.data || [])
          .filter((c) => c.id)
          .map((c) => ({
            ...c,
            localId: c.id,
          }));

        setSelectedCharacters(loaded);

        console.log("Loaded characters:", loaded);
      } catch (err) {
        console.error("Failed to load characters", err);
      }
    };

    fetchCharacters();

    return () => {
      isMounted = false;
    };
  }, [storyId, setSelectedCharacters]);


 const getBrightness = (color) => {
    if (!color) return 255;

    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);

    return (r * 299 + g * 587 + b * 114) / 1000;
  };

  const handleColorChange = (color, index) => {
    setSelectedCharacters((prev) => {
      const updated = [...prev];
      updated[index].color = color;
      return updated;
    });
  };

  // -----------------------------
  // ADD CHARACTER
  // -----------------------------
  const handleAddCharacter = () => {
    setSelectedCharacters((prev) => [
      ...prev,
      {
        localId: uuidv4(),
        name: "",
        color: "",
        img: null,
        actor_id: null,
      },
    ]);
  };

  // -----------------------------
  // UPDATE INPUT FIELDS
  // -----------------------------
  const handleCharacterInputChange = (e, index) => {
    const { name, value } = e.target;

    setSelectedCharacters((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [name]: value,
      };
      return updated;
    });
  };

  // -----------------------------
  // UPDATE IMAGE (LOCAL ONLY)
  // -----------------------------
  const handleCharacterImageChange = (file, index) => {
    if (!file) return;

    setSelectedCharacters((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        localImageFile: file,
      };
      return updated;
    });
  };

  // -----------------------------
  // DELETE CHARACTER (LOCAL ONLY)
  // -----------------------------
  const handleRemoveCharacter = (index) => {
    setSelectedCharacters((prev) => {
      const updated = [...prev];
      const removed = updated[index];

      updated.splice(index, 1);

      // track DB deletion ONLY
      if (removed?.id) {
        setDeletedCharacters((prevDeleted) => [
          ...prevDeleted,
          removed.id,
        ]);
      }

      return updated;
    });

    message.success("Charakter entfernt.");
  };

  // -----------------------------
  // DELETE FROM DB (EXTERNAL ACTION)
  // -----------------------------
  const deleteCharactersFromDB = async () => {
    if (!deletedCharacters?.length) return;

    try {
      for (const id of deletedCharacters) {
        await axios.delete(`/api/characters/${id}`);
      }

      message.success("Charaktere gelöscht.");
      setDeletedCharacters([]);
    } catch (error) {
      console.error(error);
      message.error("Fehler beim Löschen der Charaktere.");
    }
  };

  // -----------------------------
  // UPLOAD IMAGE
  // -----------------------------
  const uploadCharacterImage = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await axios.post(
        "/api/upload-character-image",
        formData
      );

      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  // -----------------------------
  // SAVE CHARACTERS
  // -----------------------------
  const saveCharacters = async (characters, responseStoryID, mode) => {
    try {
      const idMapping = {}; // oldId -> newId
  
      console.log("characters before save:", characters);
  
      for (let i = 0; i < characters.length; i++) {
        const character = characters[i];
  
        const characterData = {
          name: character.name,
          color: character.color,
          storycharid: responseStoryID,
          difficulty: "",
          actor_id: character.actor_id || null,
        };
  
        if (character.localImageFile) {
          const imgUrl = await uploadCharacterImage(character.localImageFile);
          characterData.img = imgUrl;
        } else if (character.img) {
          characterData.img = character.img;
        }
  
        if (mode === "edit") {
          if (character.id) {
            await axios.put(`/api/characters/${character.id}`, characterData);
          } else {
            const res = await axios.post(`/api/characters/`, characterData);
            const newId = res.data.newID;
            const localId = character.localId || character.id;
            idMapping[localId] = newId;
            characters[i].id = newId;
          }
        } else if (mode !== "edit") {
          const res = await axios.post(`/api/characters/`, characterData);
          const newId = res.data.newID;
          const localId = character.localId || character.id;
          idMapping[localId] = newId;
          characters[i].id = newId;
        }
      }
  
      console.log("characters after save:", characters);
  
      return idMapping; // return mapping so sentences can use new ids
    } catch (err) {
      console.error("Error saving characters:", err);
      message.error("Fehler beim Speichern der Charaktere.");
      return false;
    }
  };



  const checkCharacterHasSentences = async (characterId) => {
    try {
      const res = await axios.get(
        `/api/sentences/character/${characterId}`
      );
  
      return res.data;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  const handleRemoveCharacterById = (characterId) => {
    setSelectedCharacters((prev) => {
      const updated = [...prev];
      const index = updated.findIndex(c => c.id === characterId);
  
      if (index === -1) return prev;
  
      const removed = updated[index];
      updated.splice(index, 1);
  
      if (removed?.id) {
        setDeletedCharacters((prevDeleted) => [
          ...prevDeleted,
          removed.id,
        ]);
      }
  
      return updated;
    });
  
    message.success("Charakter entfernt.");
  };

  const requestCharacterDelete = async (character) => {
    if (!character?.id) return;
  
    const sentences = await checkCharacterHasSentences(character.id);
  
    // CASE 1: no sentences → delete directly
    if (!sentences.length) {
      handleRemoveCharacterById(character.id);
      return;
    }
  
    // CASE 2: has sentences → show modal
    Modal.confirm({
      title: "Character wird verwendet",
      content: (
        <div>
          <p>Dieser Charakter wird in folgenden Sätzen verwendet:</p>
  
          <div style={{ marginTop: 10 }}>
            {sentences.map((s) => (
              <div key={s.id}>
                • {s.text}
              </div>
            ))}
          </div>
  
          <p style={{ marginTop: 10, fontWeight: "bold" }}>
            Löschen ist nur möglich, wenn diese Sätze entfernt werden.
          </p>
        </div>
      ),
      okText: "Sätze löschen + Charakter entfernen",
      cancelText: "Abbrechen",
      onOk: async () => {
        const sentenceIds = sentences.map(s => s.id);
      
        // 1. delete from DB
        for (const s of sentences) {
          await axios.delete(`/api/sentences/${s.id}`);
        }
      
        // 2. remove from UI state immediately
        setSelectedSentences((prev) =>
          prev.filter((s) => {
            const isDbSentence = sentenceIds.includes(s.id);
            const isLocalSentence = !s.id && s.characterid === character.id;
        
            return !(isDbSentence || isLocalSentence);
          })
        );
      
        // 3. remove from delete queue if you track it
        setDeletedSentences((prev) =>
          prev.filter((id) => !sentenceIds.includes(id))
        );
      
        // 4. close character (optional)
        handleRemoveCharacterById(character.id);
      }
    });
  };

  // -----------------------------
  // RESET
  // -----------------------------
  const resetCharacters = () => {
    setSelectedCharacters([]);
    setDeletedCharacters([]);
  };

  return {
    // state
    selectedCharacters,
    deletedCharacters,

    COLOR_OPTIONS,

    // actions
    handleAddCharacter,
    handleCharacterInputChange,
    handleCharacterImageChange,
    handleRemoveCharacter,

    getBrightness,
    handleColorChange,

    // persistence
    saveCharacters,
    deleteCharactersFromDB,
    uploadCharacterImage,
    resetCharacters,

   
    

    requestCharacterDelete,
  };
}